import React, { useMemo } from "react";
import {
   Grid,
   Box,
   TextField,
   Typography,
   MenuItem,
   Button,
   Divider,
} from "@mui/material";
import ApexChart from "react-apexcharts";
import { GetQuotaChartData } from "./defineSlice";
import { useSelector, useDispatch } from "react-redux";

function DefineQuotaChart() {
   const define = useSelector((state) => state.define);
   const { quotaChartColors, quotaChartLabelNames, quotaChartSeriesData, showChart } =
      define;

   // ApexCharts mutates series internally; Redux state is frozen/non-extensible.
   const chartSeries = useMemo(
      () => JSON.parse(JSON.stringify(quotaChartSeriesData ?? [])),
      [quotaChartSeriesData]
   );
   const chartColors = useMemo(
      () => [...(quotaChartColors ?? [])],
      [quotaChartColors]
   );
   const chartLabels = useMemo(
      () => [...(quotaChartLabelNames ?? [])],
      [quotaChartLabelNames]
   );

   const options = useMemo(
      () => ({
      chart: {
         zoom: {
            enabled: true,
         },
         animations: {
            enabled: false,
         },
         toolbar: {
            show: false,
         },
      },
      tooltip: {
         y: {
           formatter: (value) => {
             const formatter = new Intl.NumberFormat("en-US");
             return formatter.format(value);
           },
         },
       },
      grid: {
         show: false,
      },
      labels: chartLabels,
      series: {
         type: "scatter",
      },
      yaxis: {
         labels: {
           formatter: (value) => {
             const formatter = new Intl.NumberFormat("en-US");
             return formatter.format(value);
           },
         },
      },
      colors: chartColors,
      interpolateNulls: false,
      markers: {
         size: 4,
      },
      stroke: {
         width: 2,
      },
      noData: {
         text: "Loading Chart...",
         align: "center",
         verticalAlign: "middle",
         offsetX: 0,
         offsetY: 0,
         style: {
            color: "#000000",
         },
      },
      legend: {
        show: true,
        showForSingleSeries: true
      }
   }),
      [chartColors, chartLabels]
   );

   if (!showChart) {
      return null;
   }

   return (
      <Grid container columns={12} spacing={2}>
         <Grid item xs={12}>
            <Box className={"DefineQuotaChart"}>
               {chartSeries.length > 0 ? (
               <ApexChart
                  options={options}
                  series={chartSeries}
                  type="line"
                  height={550}
                  width={"100%"}
               />
               ) : (
                  <Typography align="center" sx={{ py: 20 }}>
                     Loading Chart...
                  </Typography>
               )}
            </Box>
         </Grid>
      </Grid>
   );
}

export default DefineQuotaChart;
